// @core/api/endpoints/audittrail/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { CreateDataSubjectAccessRequest } from './create_data_subject_access_request';
import { CreateRetentionPolicy } from './create_retention_policy';
import { ExecuteRetentionPurge } from './execute_retention_purge';
import { ExportAuditTrail } from './export_audit_trail';
import { GenerateComplianceReport } from './generate_compliance_report';
import { GetAuditRecord } from './get_audit_record';
import { GetChainStatus } from './get_chain_status';
import { GetComplianceReport } from './get_compliance_report';
import { GetDataSubjectAccessRequest } from './get_data_subject_access_request';
import { GetRetentionPolicy } from './get_retention_policy';
import { ListAuditRecords } from './list_audit_records';
import { ListAuditRecordsByActor } from './list_audit_records_by_actor';
import { ListAuditRecordsByResource } from './list_audit_records_by_resource';
import { ListComplianceReports } from './list_compliance_reports';
import { ListDataSubjectAccessRequests } from './list_data_subject_access_requests';
import { ListRetentionPolicies } from './list_retention_policies';
import { ProcessDataSubjectAccessRequest } from './process_data_subject_access_request';
import { RecordAuditEvent } from './record_audit_event';
import { SearchAuditRecords } from './search_audit_records';
import { UpdateRetentionPolicy } from './update_retention_policy';
import { VerifyChainIntegrity } from './verify_chain_integrity';

// Re-export individual endpoints
export {
  CreateDataSubjectAccessRequest,
  CreateRetentionPolicy,
  ExecuteRetentionPurge,
  ExportAuditTrail,
  GenerateComplianceReport,
  GetAuditRecord,
  GetChainStatus,
  GetComplianceReport,
  GetDataSubjectAccessRequest,
  GetRetentionPolicy,
  ListAuditRecords,
  ListAuditRecordsByActor,
  ListAuditRecordsByResource,
  ListComplianceReports,
  ListDataSubjectAccessRequests,
  ListRetentionPolicies,
  ProcessDataSubjectAccessRequest,
  RecordAuditEvent,
  SearchAuditRecords,
  UpdateRetentionPolicy,
  VerifyChainIntegrity,
};

// Namespace export for convenient usage
export const audittrailApi = {
  CreateDataSubjectAccessRequest,
  CreateRetentionPolicy,
  ExecuteRetentionPurge,
  ExportAuditTrail,
  GenerateComplianceReport,
  GetAuditRecord,
  GetChainStatus,
  GetComplianceReport,
  GetDataSubjectAccessRequest,
  GetRetentionPolicy,
  ListAuditRecords,
  ListAuditRecordsByActor,
  ListAuditRecordsByResource,
  ListComplianceReports,
  ListDataSubjectAccessRequests,
  ListRetentionPolicies,
  ProcessDataSubjectAccessRequest,
  RecordAuditEvent,
  SearchAuditRecords,
  UpdateRetentionPolicy,
  VerifyChainIntegrity,
};
